import { render, staticRenderFns } from "./DomainsModalForm.vue?vue&type=template&id=0383a9f4&"
import script from "./DomainsModalForm.vue?vue&type=script&lang=js&"
export * from "./DomainsModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports